import successImage from '../../../assets/images/success002.png';
import alertImage from '../../../assets/images/alert001.png';

import { blue, red, teal, yellow } from 'shared/styles/colors';

export const VARIANTS = {
  error: {
    color: red.D10,
    image: alertImage,
  },
  info: {
    color: blue.D9,
    image: successImage,
  },
  success: {
    color: teal.D5,
    image: successImage,
  },
  warning: {
    color: yellow.D11,
    image: alertImage,
  },
};
